export const DEFAULT_COLOR = '#000000';

const defaultColors = [
  '#FFD358',
  '#FFB96A',
  '#FA9992',
  '#F0819D',
  '#DB5CC6',
  '#BF44DE',
  '#9E27C4',
  '#751296',
];
const numBucketsToColorMapping: Record<number, number[]> = {
  1: [2],
  2: [2, 6],
  3: [2, 4, 6],
  4: [2, 4, 6, 7],
  5: [2, 3, 4, 6, 7],
  6: [1, 2, 3, 4, 6, 7],
  7: [1, 2, 3, 4, 5, 6, 7],
  8: [0, 1, 2, 3, 4, 5, 6, 7, 8],
};

export function getColorFromValue(
  bucketNumber: number,
  numberOfBuckets: number
) {
  const colorMapping = numBucketsToColorMapping[numberOfBuckets] ?? [];
  if (colorMapping.length > bucketNumber) {
    return defaultColors[colorMapping[bucketNumber]];
  }
  return DEFAULT_COLOR;
}
